import React from 'react';
import { Handle, NodeProps, Position } from '@xyflow/react';
import {
  nodeBody,
  nodeHeader,
  nodeShellIdle,
  nodeShellSelected,
  smallNodeShell,
} from '../../canvas/nodes/nodeStyles';
import { REVIEW_SOURCE_HANDLE, ReviewSourceNodeData } from '../graphTypes';
import {
  StatusGlyph,
  accentBorder,
  reviewHandleClass,
  statusOpacity,
} from './reviewerNodeStyles';

/**
 * One thing that feeds the judge, said in one line: what it is, whether it is
 * switched on, and at most one detail (which references, how many neighbouring
 * scenes, why it does not exist yet). The node is deliberately LEAN — the graph
 * has seventeen of these, and a paragraph on each would be a wall, not a
 * picture. Everything else about a source lives in the detail column (B3).
 */
const ReviewSourceNode: React.FC<NodeProps> = ({ data, selected }) => {
  const nodeData = data as ReviewSourceNodeData;
  const { source, status } = nodeData;

  return (
    <div
      className={`${smallNodeShell} ${selected ? nodeShellSelected : nodeShellIdle} ${statusOpacity(status)}`}
      style={accentBorder(nodeData.edgeKind)}
      data-testid={`reviewer-node-source-${source.id}`}
      data-status={status}
    >
      {/* The canvas header is uppercase with wide tracking, which is right for
          a one-word type label and wrong for the backend's sentences ("how the
          clip is animated"), so the label alone opts out. */}
      <div className={nodeHeader}>
        <span className="truncate normal-case tracking-normal" title={source.label}>
          {source.label}
        </span>
        <StatusGlyph status={status} label={source.label} className="ml-auto" />
      </div>
      {source.detail && (
        <div className={nodeBody}>
          <div className="truncate" title={source.detail}>
            {source.detail}
          </div>
        </div>
      )}
      <Handle
        type="source"
        position={Position.Right}
        id={REVIEW_SOURCE_HANDLE}
        className={reviewHandleClass}
        isConnectable={false}
      />
    </div>
  );
};

export default ReviewSourceNode;
